export default async element => { // 'div[id^="teleport"]'
	const 	values = pipedValues(element.getAttribute('id'));
	[...(values['parent'] ? element.closest(values['parent']) : document).querySelectorAll(values['teleport'])].forEach(item => {
		element.appendChild(item.cloneNode(true));
		item.setAttribute('teleported','teleported');	
	});
};

function pipedValues(str){
	return str.split('|').reduce((obj,current) => {
		let pair = current.split('=');
		obj[pair[0]] = pair[1];
		return obj;
	},{});
}